module.exports = __webpack_public_path__ + "assets/img/free_13.c6c7cd5d.png";